<template>
  <v-container fluid class="me-page-shell pa-0">
    <!-- Page header — breadcrumb strip -->
    <header class="me-page__header">
      <div class="me-page__header-left">
        <v-btn
          variant="text"
          size="small"
          class="me-page__back-btn"
          :aria-label="$t('app.actions.back')"
          @click="goBack"
        >
          <v-icon start size="15">mdi-arrow-left</v-icon>
          {{ $t("app.actions.back") }}
        </v-btn>
        <span class="me-page__header-divider" aria-hidden="true"></span>
        <h1 class="me-page__title">{{ $t("me.title") }}</h1>
      </div>
      <div v-if="companyName" class="me-page__company">
        <v-icon size="15">mdi-domain</v-icon>
        <span class="me-page__company-name">{{ companyName }}</span>
      </div>
    </header>

    <UserAccountSettings @profile-loaded="onProfileLoaded">
      <template #google>
        <GoogleIdentityCard />
      </template>
    </UserAccountSettings>
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
import UserAccountSettings from "@/components/UserAccountSettings.vue";
import GoogleIdentityCard from "@/components/auth/GoogleIdentityCard.vue";

export default defineComponent({
  name: "Me",
  components: {
    UserAccountSettings,
    GoogleIdentityCard,
  },
  data() {
    return {
      companyName: "",
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // Compania vine din același fetch `/me` al setărilor; header-ul nu mai face
    // o a doua cerere doar ca să afișeze contextul de tenant.
    onProfileLoaded(profile) {
      this.companyName = profile?.companyName || "";
    },
  },
});
</script>

<style scoped>
.me-page-shell {
  max-width: 100%;
  /* Reset pentru `text-align: center` moștenit din `#app`. */
  text-align: left;
}

/* ── Breadcrumb strip ─────────────────────────────────────── */
.me-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 2px 0 12px;
  border-bottom: 1px solid var(--ncrm-color-border-default);
}

.me-page__header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1 0;
}

.me-page__back-btn {
  flex-shrink: 0;
}

.me-page__header-divider {
  flex-shrink: 0;
  width: 1px;
  height: 18px;
  background: var(--ncrm-color-border-strong);
}

.me-page__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.015em;
  color: var(--app-text-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.me-page__company {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  padding: 5px 12px;
  border-radius: var(--app-radius-pill);
  background: var(--app-neutral-chip-tonal-bg);
  border: 1px solid var(--app-neutral-chip-tonal-border);
  color: var(--app-neutral-chip-tonal-text);
  font-size: 0.78rem;
  font-weight: 700;
}

.me-page__company-name {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
